import { render, staticRenderFns } from "./EventItemDevice.vue?vue&type=template&id=a5954bf8&"
import script from "./EventItemDevice.vue?vue&type=script&lang=js&"
export * from "./EventItemDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports